import { Box, Stack, TablePagination, Typography } from "@mui/material";
import DownloadIcon from "src/assets/svg-icons/download.svg";
import FilterIcon from "src/assets/svg-icons/aggregators/filter.svg";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import GeneralLedgerTable from "./table";
import { oneBranchHasPermission } from "src/utils";
import DateRangeInput from "src/shared/components/date-range";
import moment from "moment";
import { PurchasingPermissions } from "src/constants/permissions";
import { useGetGeneralLedgerList } from "src/api/tree/general-ledger";

const GeneralLedger = () => {
  const [open, setOpen] = useState(false);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const { t } = useTranslation("purchasing");
  const [dateRange, setDateRange] = useState<{
    startDate: string;
    endDate: string;
  }>({
    startDate: "",
    endDate: "",
  });

  const [openFilter, setOpenFilter] = useState(false);
  const [refNum, setRefNum] = useState("");
  const [type, setType] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const [supplierId, setSupplierId] = useState("");
  const [accountId, setAccountId] = useState("");
  const [isGovernmentTax, setIsGovernmentTax] = useState(false);

  const filters = {
    start_date: dateRange.startDate || undefined,
    end_date: dateRange.endDate || undefined,
    // ...(!!refNum && { reference_number: refNum }),
    // ...(!!type && { type: type }),
    // ...(!!paymentId && { payment_method_id: paymentId }),
    // ...(!!supplierId && { supplier_id: supplierId }),
    // ...(!!accountId && { account_id: accountId }),
    // ...(isGovernmentTax && { has_government_tax: 1 }),
  };

  const { data, refetch, isFetching } = useGetGeneralLedgerList({
    page: pageNumber + 1,
    ...filters,
  });

  // permissions
  const addEventPermission = oneBranchHasPermission(
    PurchasingPermissions.addEvent,
  );



  const handleChangePage = (event: unknown, newPage: number) => {
    setPageNumber(newPage);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  useEffect(() => {
    setPageNumber(0);
  }, [
    refNum,
    type,
    isGovernmentTax,
    paymentId,
    supplierId,
    accountId,
    dateRange,
  ]);

  useEffect(() => {
    if (data) {
      setTotal(data.meta.total);
    }
  }, [data]);

  return (
    <Stack spacing={3} maxWidth={{ xs: "100%", md: `calc(100vw - 316px)` }}>
      <Stack
        sx={{ flexDirection: { xs: "column", md: "row" } }}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"center"}
      >
        <Typography
          fontWeight={600}
          lineHeight={"19.2px"}
          color={"#475467"}
          textTransform={"uppercase"}
        >
          {t("generalLedger")}
        </Typography>
        <Stack direction={"row"} gap={2} flexWrap={"wrap"}>
          <Box sx={{ minWidth: 207 }}>
            <DateRangeInput
              startDate={
                dateRange.startDate ? moment(dateRange.startDate) : null
              } // moment.Moment | null
              startDateId={`your_unique_start_date_id`}
              endDate={dateRange.endDate ? moment(dateRange.endDate) : null} // moment.Moment | null
              endDateId={`your_unique_end_date_id`}
              onDatesChange={(arg: {
                startDate: moment.Moment | null;
                endDate: moment.Moment | null;
              }) => {
                setDateRange({
                  startDate: arg.startDate?.format("yyyy-MM-DD") as string,
                  endDate: arg.endDate?.format("yyyy-MM-DD") as string,
                });
              }}
              showClearDates
            />
          </Box>
          {/* <Button
            color="tertiary"
            variant="outlined"
            startIcon={<img src={FilterIcon} alt="" />}
            // onClick={handleOpenFilter}
          >
            {t("filter")}
          </Button> */}
          {/* <LoadingButton
            sx={{
              border: "1px solid #98A2B3",
              height: "40px",
              fontWeight: 500,
              borderRadius: "4px",
              padding: "7px 10px",
              background: "#FCFCFD",
              fontSize: "16px",
            }}
            color="tertiary"
            variant="outlined"
            endIcon={<img src={DownloadIcon} alt="" />}
            onClick={handleDownload}
            loading={isFetchingDownload}
          >
            {t("download")}
          </LoadingButton> */}
        </Stack>
      </Stack>
      <GeneralLedgerTable data={data?.data} isFetching={isFetching} />
      <TablePagination
        rowsPerPageOptions={[20]}
        component="div"
        count={total}
        rowsPerPage={20}
        page={pageNumber}
        onPageChange={handleChangePage}
        showFirstButton
        showLastButton
      />
     
      {/* {openFilter && (
        <FilterDrawer
          open={openFilter}
          refNum={refNum}
          setRefNum={setRefNum}
          type={type}
          setType={setType}
          paymentId={paymentId}
          setPaymentId={setPaymentId}
          supplierId={supplierId}
          setSupplierId={setSupplierId}
          accountId={accountId}
          setAccountId={setAccountId}
          handleClose={handleCloseFilter}
          isGovernmentTax={isGovernmentTax}
          setIsGovernmentTax={setIsGovernmentTax}
        />
      )} */}
    </Stack>
  );
};

export default GeneralLedger;
